import React from "react";
import { BatteryDetail } from "../../../../components/user/products/detail/product/Battery";



export const Battery = () => {

    return(
        <>
        <div className="contentBox">
            <BatteryDetail/>
        </div>
        </>
    )
}